'use client';
import Button from '@/components/Button';
import { useUtmParams } from '@/lib/useUtmParams';
import { useFathomEvent } from '@/lib/hooks/useFathomEvent';
import { LEGACY_FATHOM_EVENTS } from '@/lib/fathom-events';

// TODO: Update this to use shared input component
export default function ContactUsSection() {
  const inputClassNames = `rounded-md lg:rounded-lg bg-white px-4 py-3.5 md:py-4 md:px-5 text-gray-1 placeholder:text-gray-4 text-body 
                           focus:outline-none focus:border-light-blue focus:ring-1 focus:ring-light-blue selection:bg-gray-5 col-span-full lg:col-span-1`;

  const utmParams = useUtmParams();
  const trackPricingRequestSubmission = useFathomEvent(LEGACY_FATHOM_EVENTS.PRICING_REQUEST);

  const handleSubmit = () => {
    trackPricingRequestSubmission();
  };

  return (
    <section
      id="PricingContactUsSection"
      className="selection:text-fuchsia-900 py-section flex flex-col items-center gap-5 bg-dark-background px-8 md:gap-8"
    >
      <h1 className="text-h3 text-center text-white">Contact a member of our team</h1>
      <h3 className="text-eyebrow max-w-[30rem] text-center text-white">
        If you have further questions, we invite you to connect with a member of our team
      </h3>
      {/* Pardot form */}
      <form
        acceptCharset="UTF-8"
        method="POST"
        action="https://go.gradle.com/l/68052/2023-11-10/n3m22c"
        className="grid w-full max-w-lg grid-cols-2 gap-5 lg:max-w-4xl lg:gap-y-8"
        onSubmit={handleSubmit}
      >
        <input
          type="text"
          required
          name={'first_name'}
          className={inputClassNames}
          maxLength={40}
          placeholder={'First name*'}
        />
        <input
          type="text"
          required
          name={'last_name'}
          className={inputClassNames}
          maxLength={80}
          placeholder={'Last name*'}
        />
        <input
          type="email"
          required
          name={'email'}
          className={inputClassNames}
          maxLength={255}
          placeholder={'Email*'}
        />
        <input
          type="text"
          required
          name={'company'}
          className={inputClassNames}
          maxLength={30}
          placeholder={'Company*'}
        />
        <textarea
          className="text-body col-span-full h-44 resize-none rounded-md bg-white px-4 py-3.5 text-gray-1 selection:bg-gray-5 placeholder:text-gray-4 focus:border-light-blue focus:outline-none focus:ring-1 focus:ring-light-blue md:px-5 md:py-4 lg:rounded-lg"
          name={'message'}
          rows={4}
          placeholder={"I'd like to get a pricing estimate for my team..."}
        />
        <p className="text-sm col-span-full text-center text-gray-4">
          By submitting this form, you agree to accept Gradle&apos;s{' '}
          <a href="/legal/terms-of-use/" className="text-white underline hover:text-gradle-blue">
            terms
          </a>{' '}
          and{' '}
          <a href="/legal/privacy/" className="text-white underline hover:text-gradle-blue">
            privacy policy
          </a>
          .
        </p>
        {['utm_source', 'utm_content', 'utm_medium', 'utm_campaign'].map(key => (
          <input key={key} type="hidden" id={key} name={key} value={utmParams[key]} />
        ))}
        <Button type="submit" variant="primary" className="col-span-full w-full place-self-center md:w-auto">
          Get Pricing
        </Button>
      </form>
    </section>
  );
}
